<div class="desktop-cover">
    <img class="logo" src="../../../content/images/logo-logbook-high.svg" alt="logbook"/>
    <form class="login-form" [formGroup]="loginForm" (ngSubmit)="login()">
        <dln-input
            label="E-mail"
            type="email"
            inputName="email"
            [required]="true"
            [control]="email"
            [asterisk]="false">
        </dln-input>


        <dln-input
            label="Password"
            type="password"
            inputName="password"
            [required]="true"
            [control]="password"
            [asterisk]="false">
        </dln-input>

        <div class="buttons-container">
            <dln-button class="login-btn" idBtn="login-btn" class="login-btn" (onClick)="login()" [label]="'Log-in'" type="submit"
                        [isLoading]="loginForm.pending"></dln-button>

            <div class="error-msg" *ngIf="authenticationError" [innerHTML]="authenticationError">
            </div>
            <div class="log-out-msg" *ngIf="authenticationLogout">
                You've logged out
            </div>
            <div class="rmb-forgot-container">
                <label class="form-check-label" for="rememberMe">
                    <input type="checkbox" name="rememberMe" id="rememberMe" [formControl]="rememberMe"/>
                    <span>Remember me</span>
                </label>
                <div class="vertical-divider"></div>
                <a class="password-forgotten" routerLink="password-reset/init">Password Forgotten?</a>
            </div>
            <div class="divider"></div>
            <span class="no-account">Don't have an account yet?</span>
            <dln-button routerLink="sign-up" idBtn="sign-up-btn" [label]="'Sign up'" [color]="'black'"></dln-button>
        </div>
    </form>
</div>
